import React from 'react';
import ReactDOM from 'react-dom/client';
import './base.css';
import App from './App';
import './firebase'; // Make sure firebase is imported here

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);